import { useEffect } from "react";
import { useRoutes } from "react-router-dom";

import { routesPublic, routesAdmin, routesUserLogedIn } from "./routes";
import useUserStore from "./store/useUserStore";

const App = () => {
  const { user, userCheckToken } = useUserStore((state) => state);

  useEffect(() => {
    userCheckToken();
  }, [user, userCheckToken]);

  let activeRoutes;

  if (user?.isAdmin) {
    activeRoutes = routesAdmin;
  } else if (!user?.isAdmin) {
    activeRoutes = routesUserLogedIn;
  } else {
    activeRoutes = routesPublic;
  }

  // React-Router-Dom misch Routendefintion mit Layout und Seiten

  const content = useRoutes(activeRoutes);

  return <>{content}</>;
};

export default App;
